function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/controller/datacontroller
 */
import mix from '@ckeditor/ckeditor5-utils/src/mix';
import ObservableMixin from '@ckeditor/ckeditor5-utils/src/observablemixin';
import CKEditorError from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
import Mapper from '../conversion/mapper';
import DowncastDispatcher from '../conversion/downcastdispatcher';
import { insertText } from '../conversion/downcasthelpers';
import UpcastDispatcher from '../conversion/upcastdispatcher';
import { convertText, convertToModelFragment } from '../conversion/upcasthelpers';
import ViewDocumentFragment from '../view/documentfragment';
import ViewDocument from '../view/document';
import ViewDowncastWriter from '../view/downcastwriter';
import ModelRange from '../model/range';
import { autoParagraphEmptyRoots } from '../model/utils/autoparagraphing';
import HtmlDataProcessor from '../dataprocessor/htmldataprocessor';
/**
 * Controller for the data pipeline. The data pipeline controls how data is retrieved from the document
 * and set inside it. Hence, the controller features two methods which allow to {@link ~DataController#get get}
 * and {@link ~DataController#set set} data of the {@link ~DataController#model model}
 * using given:
 *
 * * {@link module:engine/dataprocessor/dataprocessor~DataProcessor data processor},
 * * downcast converters,
 * * upcast converters.
 *
 * An instance of the data controller is always available in the {@link module:core/editor/editor~Editor#data `editor.data`}
 * property:
 *
 *		editor.data.get( { rootName: 'customRoot' } ); // -> '<p>Hello!</p>'
 *
 * @mixes module:utils/observablemixin~ObservableMixin
 */

var DataController = /*#__PURE__*/function () {
  /**
   * Creates a data controller instance.
   *
   * @param {module:engine/model/model~Model} model Data model.
   * @param {module:engine/view/stylesmap~StylesProcessor} stylesProcessor The styles processor instance.
   */
  function DataController(model, stylesProcessor) {
    var _this = this;

    _classCallCheck(this, DataController);

    /**
     * Data model.
     *
     * @readonly
     * @member {module:engine/model/model~Model}
     */
    this.model = model;
    /**
     * Mapper used for the conversion. It has no permanent bindings, because they are created when getting data and
     * cleared directly after the data are converted. However, the mapper is defined as a class property, because
     * it needs to be passed to the `DowncastDispatcher` as a conversion API.
     *
     * @readonly
     * @member {module:engine/conversion/mapper~Mapper}
     */

    this.mapper = new Mapper();
    /**
     * Downcast dispatcher used by the {@link #get get method}. Downcast converters should be attached to it.
     *
     * @readonly
     * @member {module:engine/conversion/downcastdispatcher~DowncastDispatcher}
     */

    this.downcastDispatcher = new DowncastDispatcher({
      mapper: this.mapper,
      schema: model.schema
    });
    this.downcastDispatcher.on('insert:$text', insertText(), {
      priority: 'lowest'
    });
    /**
     * Upcast dispatcher used by the {@link #set set method}. Upcast converters should be attached to it.
     *
     * @readonly
     * @member {module:engine/conversion/upcastdispatcher~UpcastDispatcher}
     */

    this.upcastDispatcher = new UpcastDispatcher({
      schema: model.schema
    });
    /**
     * The view document used by the data controller.
     *
     * @readonly
     * @member {module:engine/view/document~Document}
     */

    this.viewDocument = new ViewDocument(stylesProcessor);
    /**
     * Styles processor used during the conversion.
     *
     * @readonly
     * @member {module:engine/view/stylesmap~StylesProcessor}
     */

    this.stylesProcessor = stylesProcessor;
    /**
     * Data processor used specifically for HTML conversion.
     *
     * @readonly
     * @member {module:engine/dataprocessor/htmldataprocessor~HtmlDataProcessor} #htmlProcessor
     */

    this.htmlProcessor = new HtmlDataProcessor(this.viewDocument);
    /**
     * Data processor used during the conversion.
     * Same instance as {@link #htmlProcessor} by default. Can be replaced at run time to handle different format, e.g. XML or Markdown.
     *
     * @member {module:engine/dataprocessor/dataprocessor~DataProcessor} #processor
     */

    this.processor = this.htmlProcessor;
    /**
     * The view downcast writer just for data conversion purposes, i.e. to modify
     * the {@link #viewDocument}.
     *
     * @private
     * @readonly
     * @member {module:engine/view/downcastwriter~DowncastWriter}
     */

    this._viewWriter = new ViewDowncastWriter(this.viewDocument); // Define default converters for text and elements.
    //
    // Note that if there is no default converter for the element it will be skipped, for instance `<b>foo</b>` will be
    // converted to nothing. We therefore add `convertToModelFragment` as a last converter so it converts children of that
    // element to the document fragment and so `<b>foo</b>` will be converted to `foo` if there is no converter for `<b>`.

    this.upcastDispatcher.on('text', convertText(), {
      priority: 'lowest'
    });
    this.upcastDispatcher.on('element', convertToModelFragment(), {
      priority: 'lowest'
    });
    this.upcastDispatcher.on('documentFragment', convertToModelFragment(), {
      priority: 'lowest'
    });
    this.decorate('init');
    this.decorate('set'); // Fire the `ready` event when the initialization has completed. Such low-level listener gives possibility
    // to plug into the initialization pipeline without interrupting the initialization flow.

    this.on('init', function () {
      _this.fire('ready');
    }, {
      priority: 'lowest'
    }); // Fix empty roots after DataController is 'ready' (note that init method could be decorated and stopped).
    // We need to handle this event because initial data could be empty and post-fixer would not get triggered.

    this.on('ready', function () {
      _this.model.enqueueChange('transparent', autoParagraphEmptyRoots);
    }, {
      priority: 'lowest'
    });
  }
  /**
   * Returns the model's data converted by downcast dispatchers attached to {@link #downcastDispatcher} and
   * formatted by the {@link #processor data processor}.
   *
   * @param {Object} [options] Additional configuration for the retrieved data. `DataController` provides two optional
   * properties: `rootName` and `trim`. Other properties of this object are specified by various editor features.
   * @param {String} [options.rootName='main'] Root name.
   * @param {String} [options.trim='empty'] Whether returned data should be trimmed. This option is set to `empty` by default,
   * which means whenever editor content is considered empty, an empty string will be returned. To turn off trimming completely
   * use `'none'`. In such cases exact content will be returned (for example `<p>&nbsp;</p>` for an empty editor).
   * @returns {String} Output data.
   */


  _createClass(DataController, [{
    key: "get",
    value: function get() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _options$rootName = options.rootName,
          rootName = _options$rootName === void 0 ? 'main' : _options$rootName,
          _options$trim = options.trim,
          trim = _options$trim === void 0 ? 'empty' : _options$trim;

      if (!this._checkIfRootsExists([rootName])) {
        /**
         * Cannot get data from a non-existing root. This error is thrown when {@link #get DataController#get() method}
         * is called with non-existent root name. For example, if there is an editor instance with only `main` root,
         * calling {@link #get} like:
         *
         *		data.get( { rootName: 'root2' } );
         *
         * will throw this error.
         *
         * @error datacontroller-get-non-existent-root
         */
        throw new CKEditorError('datacontroller-get-non-existent-root', this);
      }

      var root = this.model.document.getRoot(rootName);

      if (trim === 'empty' && !this.model.hasContent(root, {
        ignoreWhitespaces: true
      })) {
        return '';
      }

      return this.stringify(root, options);
    }
    /**
     * Returns the content of the given {@link module:engine/model/element~Element model's element} or
     * {@link module:engine/model/documentfragment~DocumentFragment model document fragment} converted by the downcast converters
     * attached to {@link #downcastDispatcher} and formatted by the {@link #processor data processor}.
     *
     * @param {module:engine/model/element~Element|module:engine/model/documentfragment~DocumentFragment} modelElementOrFragment
     * Element whose content will be stringified.
     * @param {Object} [options] Additional configuration passed to the conversion process.
     * @returns {String} Output data.
     */

  }, {
    key: "stringify",
    value: function stringify(modelElementOrFragment) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Model -> view.
      var viewDocumentFragment = this.toView(modelElementOrFragment, options); // View -> data.

      return this.processor.toData(viewDocumentFragment);
    }
    /**
     * Returns the content of the given {@link module:engine/model/element~Element model element} or
     * {@link module:engine/model/documentfragment~DocumentFragment model document fragment} converted by the downcast
     * converters attached to {@link #downcastDispatcher} to a
     * {@link module:engine/view/documentfragment~DocumentFragment view document fragment}.
     *
     * @param {module:engine/model/element~Element|module:engine/model/documentfragment~DocumentFragment} modelElementOrFragment
     * Element or document fragment whose content will be converted.
     * @param {Object} [options={}] Additional configuration that will be available through
     * {@link module:engine/conversion/downcastdispatcher~DowncastConversionApi#options} during the conversion process.
     * @returns {module:engine/view/documentfragment~DocumentFragment} Output view DocumentFragment.
     */

  }, {
    key: "toView",
    value: function toView(modelElementOrFragment) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var viewDocument = this.viewDocument;
      var viewWriter = this._viewWriter; // Clear bindings so the call to this method gives correct results.

      this.mapper.clearBindings(); // First, convert elements.

      var modelRange = ModelRange._createIn(modelElementOrFragment);

      var viewDocumentFragment = new ViewDocumentFragment(viewDocument);
      this.mapper.bindElements(modelElementOrFragment, viewDocumentFragment); // Make additional options available during conversion process through `conversionApi`.

      this.downcastDispatcher.conversionApi.options = options; // We have no view controller and rendering to DOM in DataController so view.change() block is not used here.

      this.downcastDispatcher.convertInsert(modelRange, viewWriter); // Convert markers.
      // For document fragment, simply take the markers assigned to this document fragment.
      // For model root, all markers in that root will be taken.
      // For model element, we need to check which markers are intersecting with this element and relatively modify the markers' ranges.
      // Collapsed markers at element boundary, although considered as not intersecting with the element, will also be returned.

      var markers = modelElementOrFragment.is('documentFragment') ? Array.from(modelElementOrFragment.markers) : _getMarkersRelativeToElement(modelElementOrFragment);

      var _iterator = _createForOfIteratorHelper(markers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ref3 = _step.value;

          var _ref2 = _slicedToArray(_ref3, 2);

          var name = _ref2[0];
          var range = _ref2[1];
          this.downcastDispatcher.convertMarkerAdd(name, range, viewWriter);
        } // Clean `conversionApi`.

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      delete this.downcastDispatcher.conversionApi.options;
      return viewDocumentFragment;
    }
    /**
     * Sets initial input data parsed by the {@link #processor data processor} and
     * converted by the {@link #upcastDispatcher view-to-model converters}.
     * Initial data can be set only to document that {@link module:engine/model/document~Document#version} is equal 0.
     *
     * **Note** This method is {@link module:utils/observablemixin~ObservableMixin#decorate decorated} which is
     * used by e.g. collaborative editing plugin that syncs remote data on init.
     *
     * When data is passed as a string it is initialized on a default `main` root:
     *
     *		dataController.init( '<p>Foo</p>' ); // Initializes data on the `main` root.
     *
     * To initialize data on a different root or multiple roots at once, object containing `rootName` - `data` pairs should be passed:
     *
     *		dataController.init( { main: '<p>Foo</p>', title: '<h1>Bar</h1>' } ); // Initializes data on the `main` and `title` roots.
     *
     * @fires init
     * @param {String|Object.<String,String>} data Input data as a string or an object containing `rootName` - `data`
     * pairs to initialize data on multiple roots at once.
     * @returns {Promise} Promise that is resolved after the data is set on the editor.
     */

  }, {
    key: "init",
    value: function init(data) {
      var _this2 = this;

      if (this.model.document.version) {
        /**
         * Cannot set initial data to not empty {@link module:engine/model/document~Document}.
         * Initial data should be set once, during {@link module:core/editor/editor~Editor} initialization,
         * when the {@link module:engine/model/document~Document#version} is equal 0.
         *
         * @error datacontroller-init-document-not-empty
         */
        throw new CKEditorError('datacontroller-init-document-not-empty', this);
      }

      var initialData = {};

      if (typeof data === 'string') {
        initialData.main = data; // Default root is 'main'. To initiate data on a different root, object should be passed.
      } else {
        initialData = data;
      }

      if (!this._checkIfRootsExists(Object.keys(initialData))) {
        /**
         * Cannot init data on a non-existing root. This error is thrown when {@link #init DataController#init() method}
         * is called with non-existent root name. For example, if there is an editor instance with only `main` root,
         * calling {@link #init} like:
         *
         * 		data.init( { main: '<p>Foo</p>', root2: '<p>Bar</p>' } );
         *
         * will throw this error.
         *
         * @error datacontroller-init-non-existent-root
         */
        throw new CKEditorError('datacontroller-init-non-existent-root', this);
      }

      this.model.enqueueChange('transparent', function (writer) {
        for (var _i2 = 0, _Object$keys = Object.keys(initialData); _i2 < _Object$keys.length; _i2++) {
          var rootName = _Object$keys[_i2];

          var modelRoot = _this2.model.document.getRoot(rootName);

          writer.insert(_this2.parse(initialData[rootName], modelRoot), modelRoot, 0);
        }
      });
      return Promise.resolve();
    }
    /**
     * Sets input data parsed by the {@link #processor data processor} and
     * converted by the {@link #upcastDispatcher view-to-model converters}.
     * This method can be used any time to replace existing editor data by the new one without clearing the
     * {@link module:engine/model/document~Document#history document history}.
     *
     * This method also creates a batch with all the changes applied. If all you need is to parse data, use
     * the {@link #parse} method.
     *
     * When data is passed as a string it is set on a default `main` root:
     *
     *		dataController.set( '<p>Foo</p>' ); // Sets data on the `main` root.
     *
     * To set data on a different root or multiple roots at once, object containing `rootName` - `data` pairs should be passed:
     *
     *		dataController.set( { main: '<p>Foo</p>', title: '<h1>Bar</h1>' } ); // Sets data on the `main` and `title` roots.
     *
     * To set the data with preserved undo stacks and set the current change to this stack, use the `{ batchType: 'default' }` option.
     *
     *		dataController.set( '<p>Foo</p>', { batchType: 'default' } ); // Sets data as a new change.
     *
     * @fires set
     * @param {String|Object.<String,String>} data Input data as a string or an object containing `rootName` - `data`
     * pairs to set data on multiple roots at once.
     * @param {Object} [options={}] Options for setting data.
     * @param {'default'|'transparent'} [options.batchType='default'] The batch type that will be used to create a batch for the changes.
     * When set to `default`, the undo and redo stacks will be preserved. Note that when not set, the undo feature (when present) will
     * override it to `transparent` and all undo steps will be lost.
     */

  }, {
    key: "set",
    value: function set(data) {
      var _this3 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var newData = {};

      if (typeof data === 'string') {
        newData.main = data; // Default root is 'main'. To set data on a different root, object should be passed.
      } else {
        newData = data;
      }

      if (!this._checkIfRootsExists(Object.keys(newData))) {
        /**
         * Cannot set data on a non-existing root. This error is thrown when {@link #set DataController#set() method}
         * is called with non-existent root name. For example, if there is an editor instance with only `main` root,
         * calling {@link #set} like:
         *
         * 		data.set( { main: '<p>Foo</p>', root2: '<p>Bar</p>' } );
         *
         * will throw this error.
         *
         * @error datacontroller-set-non-existent-root
         */
        throw new CKEditorError('datacontroller-set-non-existent-root', this);
      }

      var batchType = options.batchType || 'default';
      this.model.enqueueChange(batchType, function (writer) {
        writer.setSelection(null);
        writer.removeSelectionAttribute(_this3.model.document.selection.getAttributeKeys());

        for (var _i3 = 0, _Object$keys2 = Object.keys(newData); _i3 < _Object$keys2.length; _i3++) {
          var rootName = _Object$keys2[_i3];

          // Save to model.
          var modelRoot = _this3.model.document.getRoot(rootName);

          writer.remove(writer.createRangeIn(modelRoot));
          writer.insert(_this3.parse(newData[rootName], modelRoot), modelRoot, 0);
        }
      });
    }
    /**
     * Returns the data parsed by the {@link #processor data processor} and then converted by upcast converters
     * attached to the {@link #upcastDispatcher}.
     *
     * @see #set
     * @param {String} data Data to parse.
     * @param {module:engine/model/schema~SchemaContextDefinition} [context='$root'] Base context in which the view will
     * be converted to the model. See: {@link module:engine/conversion/upcastdispatcher~UpcastDispatcher#convert}.
     * @returns {module:engine/model/documentfragment~DocumentFragment} Parsed data.
     */

  }, {
    key: "parse",
    value: function parse(data) {
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '$root';
      // data -> view
      var viewDocumentFragment = this.processor.toView(data); // view -> model

      return this.toModel(viewDocumentFragment, context);
    }
    /**
     * Returns the result of the given {@link module:engine/view/element~Element view element} or
     * {@link module:engine/view/documentfragment~DocumentFragment view document fragment} converted by the
     * {@link #upcastDispatcher view-to-model converters}, wrapped by {@link module:engine/model/documentfragment~DocumentFragment}.
     *
     * When marker elements were converted during the conversion process, it will be set as a document fragment's
     * {@link module:engine/model/documentfragment~DocumentFragment#markers static markers map}.
     *
     * @param {module:engine/view/element~Element|module:engine/view/documentfragment~DocumentFragment} viewElementOrFragment
     * Element or document fragment whose content will be converted.
     * @param {module:engine/model/schema~SchemaContextDefinition} [context='$root'] Base context in which the view will
     * be converted to the model. See: {@link module:engine/conversion/upcastdispatcher~UpcastDispatcher#convert}.
     * @returns {module:engine/model/documentfragment~DocumentFragment} Output document fragment.
     */

  }, {
    key: "toModel",
    value: function toModel(viewElementOrFragment) {
      var _this4 = this;

      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '$root';
      return this.model.change(function (writer) {
        return _this4.upcastDispatcher.convert(viewElementOrFragment, writer, context);
      });
    }
    /**
     * Adds a style processor normalization rules.
     *
     * You can implement your own rules as well as use one of the available processor rules:
     *
     * * background: {@link module:engine/view/styles/background~addBackgroundRules}
     * * border: {@link module:engine/view/styles/border~addBorderRules}
     * * margin: {@link module:engine/view/styles/margin~addMarginRules}
     * * padding: {@link module:engine/view/styles/padding~addPaddingRules}
     *
     * @param {Function} callback
     */

  }, {
    key: "addStyleProcessorRules",
    value: function addStyleProcessorRules(callback) {
      callback(this.stylesProcessor);
    }
    /**
     * Registers a {@link module:engine/view/matcher~MatcherPattern} on {@link #htmlProcessor htmlProcessor}
     * and {@link #processor processor} for view elements whose content should be treated as a raw data
     * and not processed during conversion from DOM to view elements.
     *
     * The raw data can be later accessed by {@link module:engine/view/element~Element#getCustomProperty view element custom property}
     * `"$rawContent"`.
     *
     * @param {module:engine/view/matcher~MatcherPattern} pattern Pattern matching all view elements whose content should
     * be treated as a raw data.
     */

  }, {
    key: "registerRawContentMatcher",
    value: function registerRawContentMatcher(pattern) {
      // No need to register the pattern if both `htmlProcessor` and `processor` are the same instances.
      if (this.processor && this.processor !== this.htmlProcessor) {
        this.processor.registerRawContentMatcher(pattern);
      }

      this.htmlProcessor.registerRawContentMatcher(pattern);
    }
    /**
     * Removes all event listeners set by the DataController.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.stopListening();
    }
    /**
     * Checks if all provided root names are existing editor roots.
     *
     * @private
     * @param {Array.<String>} rootNames Root names to check.
     * @returns {Boolean} Whether all provided root names are existing editor roots.
     */

  }, {
    key: "_checkIfRootsExists",
    value: function _checkIfRootsExists(rootNames) {
      var _iterator2 = _createForOfIteratorHelper(rootNames),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var rootName = _step2.value;

          if (!this.model.document.getRootNames().includes(rootName)) {
            return false;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return true;
    }
    /**
     * Event fired once the data initialization has finished.
     *
     * @event ready
     */

    /**
     * Event fired after the {@link #init `init()` method} was run. It can be {@link #listenTo listened to} in order to adjust or modify
     * the initialization flow. However, if the `init` event is stopped or prevented, the {@link #event:ready `ready` event}
     * should be fired manually.
     *
     * The `init` event is fired by the decorated {@link #init} method.
     * See {@link module:utils/observablemixin~ObservableMixin#decorate} for more information and samples.
     *
     * @event init
     */

    /**
     * Event fired after {@link #set set() method} has been run.
     *
     * The `set` event is fired by decorated {@link #set} method.
     * See {@link module:utils/observablemixin~ObservableMixin#decorate} for more information and samples.
     *
     * @event set
     */

  }]);

  return DataController;
}();

export { DataController as default };
mix(DataController, ObservableMixin); // Helper function for downcast conversion.
//
// Takes a document element (element that is added to a model document) and checks which markers are inside it. If the marker is collapsed
// at element boundary, it is considered as contained inside the element and marker range is returned. Otherwise, if the marker is
// intersecting with the element, the intersection is returned.

function _getMarkersRelativeToElement(element) {
  var result = [];
  var doc = element.root.document;

  if (!doc) {
    return [];
  }

  var elementRange = ModelRange._createIn(element);

  var _iterator3 = _createForOfIteratorHelper(doc.model.markers),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var marker = _step3.value;
      var markerRange = marker.getRange();
      var isMarkerCollapsed = markerRange.isCollapsed;
      var isMarkerAtElementBoundary = markerRange.start.isEqual(elementRange.start) || markerRange.end.isEqual(elementRange.end);

      if (isMarkerCollapsed && isMarkerAtElementBoundary) {
        result.push([marker.name, markerRange]);
      } else {
        var updatedMarkerRange = elementRange.getIntersection(markerRange);

        if (updatedMarkerRange) {
          result.push([marker.name, updatedMarkerRange]);
        }
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return result;
}